var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"desc-warp"},[_c('div',{staticClass:"desc-box one-line"},_vm._l((_vm.Contents),function(item,idx){return _c('span',{key:idx,staticClass:"desc"},[_vm._v(_vm._s(item.Content))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebaf1504","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/template/desc/SingleDesc.vue
// module id = null
// module chunks = 